// extracted by mini-css-extract-plugin
export var fullGrid = "_3u-3";
export var pdpPreviewContainer = "_3u-1";
export var previewContainer = "_3u-0";
export var togglePreviewContainer = "_3u-2";